// The API can reply with an invalid HTTP status (e.g. 0). The browser then aborts the
// request, but the JSON body is still available on the XHR.
export const getBodyMessage = (error: any): string | null => {
    try {
        const text = String(JSON.parse(error.request.responseText).message ?? "");
        return /exception|stack trace|\sat\s\S+\(|object reference|sqlclient/i.test(text) || text.length > 300
            ? "Unable to complete the action. Please contact the dev support team."
            : text || null;
    } catch {
        return null;
    }
};

export const getErrorMessage = (error: any, pagename: string, action: string) => {
    const isVpnError = (message: string) =>
        message?.toLowerCase().includes("vpn");
    if (!navigator.onLine) {
        return "Please check your Internet connection and try again.";
    }

    if (error?.message === "Network Error" || (error?.request && !error?.response)) {
        return "Please check your VPN connection or the server may be unreachable.";
    }

    const serverMessage = error?.response?.data?.message;

    if (serverMessage) {
        return Array.isArray(serverMessage)
            ? serverMessage.join(", ")
            : serverMessage;
    }
    switch (action.toLowerCase()) {
        case "fetch":
            return `Problem occurred while fetching ${pagename}. Please try again later.`;
        case "add":
            return `Problem occurred while adding ${pagename}. Please try again later.`;
        case "update":
            return `Problem occurred while updating ${pagename}. Please try again later.`;
        case "delete":
            return `Problem occurred while deleting ${pagename}. Please try again later.`;
        case "check in":
            return `Problem occurred while checking in ${pagename}. Please try again later.`;
        case "check out":
            return `Problem occurred while checking out ${pagename}. Please try again later.`;
        case "extend":
            return `Problem occurred while extending ${pagename}. Please try again later.`;
        case "cut power":
            return `Problem occurred while cutting power for ${pagename}. Please try again later.`;
        case "restore power":
            return `Problem occurred while restoring power for ${pagename}. Please try again later.`;
        case "transfer":
            return `Problem occurred while transferring ${pagename}. Please try again later.`;
        default:
            return `An unexpected error occurred while processing ${pagename}. Please try again later or contact the dev support team.`;
    }
};
